export default {
  category: '商城&商品',
};
